"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var caches = {};
function deprecate(method, message, help) {
    if (types_1.isFn(method)) {
        return function (p1, p2, p3, p4, p5) {
            deprecate(message, help);
            return method.apply(this, arguments);
        };
    }
    if (types_1.isStr(method) && !caches[method]) {
        caches[method] = true;
        console.warn(new Error(method + " has been deprecated. Do not continue to use this api." + (message ||
            '')));
    }
}
exports.deprecate = deprecate;
